import React from 'react';

export default class DelayShow extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isReady: props === 0
    };
  }

  componentDidMount() {
    const { delay } = this.props;
    const { isReady } = this.state;
    if (!isReady) {
      this.timeoutHook = setTimeout(() => {
        this.setState({ isReady: true });
      }, delay);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutHook);
  }

  render() {
    const { children } = this.props;
    const { isReady } = this.state;
    if (!isReady) {
      return null;
    }
    return children;
  }
}

DelayShow.defaultProps = {
  delay: 600
};
